import {
  movieMetroMac1,
  movieMetroMac2,
  movieMetroTab1,
  movieMetroTab2,
  movieMetroPhone1,
  movieMetroPhone2,
  movieMetroPhone3,
  portfolioMac1,
  portfolioMac2,
  portfolioTab1,
  portfolioTab2,
  portfolioPhone1,
  portfolioPhone2,
  portfolioPhone3,
  portfolioTempPhone1,
  portfolioTempPhone2,
  portfolioTempPhone3,
  portfolioTempMac1,
  portfolioTempMac2,
  portfolioTempTab1,
  portfolioTempTab2,
  defineMac1,
  defineMac2,
  defineTab1,
  defineTab2,
  definePhone1,
  definePhone2,
  definePhone3,
  abadcoMac1,
  abadcoMac2,
  abadcoTab1,
  abadcoTab2,
  abadcoPhone1,
  abadcoPhone2,
  abadcoPhone3,
  austinRoyMac1,
  austinRoyMac2,
  austinRoyTab1,
  austinRoyTab2,
  austinRoyPhone1,
  austinRoyPhone2,
  austinRoyPhone3,
  threeGracesMac1,
  threeGracesMac2,
  threeGracesTab1,
  threeGracesTab2,
  threeGracesPhone1,
  threeGracesPhone2,
  threeGracesPhone3,
} from '../assets';

export type ProjectDataType = {
  id: string;
  sequence: number;
  title: string;
  text: string[];
  secondary: string[];
  phoneImgSrc: string[];
  desktopImgSrc: string[] | [];
  tabletImgSrc: string[];
  mobileFirst: boolean;
  githubLink: string;
  liveLink: string;
  next: string;
};

export const ProjectData: ProjectDataType[] = [
  {
    id: 'define-consult',
    sequence: 1,
    title: 'Define Consult',
    text: [
      "This is a site for a company called Define Consult that's a web design agency. I'm still currently building it but so far the progress is presentable. I'm really proud of what I've achieved with this project as it's pushed me to further go an extra mile on UI/UX Design and Frontend Development. It's also responsive to different screen sizes. The GitHub repo is private, but can be availed access upon special circumstances.",
    ],
    secondary: [
      'Next.js',
      'JavaScript',
      'TypeScript',
      'SCSS',
      'GSAP',
      'Framer Motion',
    ],
    phoneImgSrc: [definePhone1, definePhone2, definePhone3],
    desktopImgSrc: [defineMac1, defineMac2],
    tabletImgSrc: [defineTab1, defineTab2],
    mobileFirst: false,
    githubLink: 'https://github.com/shaqdeff/Define-Consult',
    liveLink: 'https://defineco.netlify.app/',
    next: 'portfolio',
  },
  {
    id: 'portfolio',
    sequence: 2,
    title: 'Portfolio',
    text: [
      'Rated number 1 in the best web developer templates of 2023 by Sanity CMS, this is a portfolio template designed to showcase skills, experience, and accomplishments in a visually appealing and professional manner. I decided to put it up on GitHub as an open-source resource to help individuals to learn, adapt, and create their own portfolios. Currently, over 200 people have used it to create their portfolios.',
    ],
    secondary: ['React', 'Three.js', 'Framer Motion', 'TailwindCSS'],
    phoneImgSrc: [
      portfolioTempPhone1,
      portfolioTempPhone2,
      portfolioTempPhone3,
    ],
    desktopImgSrc: [portfolioTempMac1, portfolioTempMac2],
    tabletImgSrc: [portfolioTempTab1, portfolioTempTab2],
    mobileFirst: true,
    githubLink: 'https://github.com/shaqdeff/Portfolio-Template',
    liveLink: 'https://shaq-portfolio.netlify.app/',
    next: 'austin-roy',
  },
  {
    id: 'austin-roy',
    sequence: 3,
    title: 'Austin Roy',
    text: [
      'This is a personal site for UI/UX developer Austin Roy. It includes an about page, blog, and contact page, the blog and contact page still under construction. You can however still interact with it. The about page is all WebGL/Three.js.',
    ],
    secondary: ['Next.js', 'TypeScript', 'Three.js', 'TailwindCSS', 'GSAP'],
    phoneImgSrc: [austinRoyPhone1, austinRoyPhone2, austinRoyPhone3],
    desktopImgSrc: [austinRoyMac1, austinRoyMac2],
    tabletImgSrc: [austinRoyTab1, austinRoyTab2],
    mobileFirst: true,
    githubLink: 'https://github.com/shaqdeff/Austin-Roy',
    liveLink: 'https://austin-roy.netlify.app/',
    next: 'shaquille',
  },
  {
    id: 'shaquille',
    sequence: 4,
    title: 'Shaquille',
    text: [
      `This is my personal portfolio site, which I believe you're currently in/experiencing. It consists of a home page, projects page to showcase my works, and an about page that expounds more on me as a software developer. The GitHub repo is private though, but can be availed access upon request.`,
    ],
    secondary: [
      'React',
      'TypeScript',
      'Three.js',
      'Framer Motion',
      'Styled Components',
      'SCSS',
      'TailwindCSS',
    ],
    phoneImgSrc: [portfolioPhone1, portfolioPhone2, portfolioPhone3],
    desktopImgSrc: [portfolioMac1, portfolioMac2],
    tabletImgSrc: [portfolioTab1, portfolioTab2],
    mobileFirst: true,
    githubLink: 'https://github.com/shaqdeff',
    liveLink: 'https://shaquillendunda.netlify.app/',
    next: 'movie-metro',
  },
  {
    id: 'movie-metro',
    sequence: 5,
    title: 'Movie Metro',
    text: [
      "Movie Metro is a single-page application that allows users to search for any movie or show's ratings and its details. It fetches data using the OMDB API and was built with React and Redux.",
    ],
    secondary: ['React', 'Redux', 'SASS', 'OMDB API'],
    phoneImgSrc: [movieMetroPhone1, movieMetroPhone2, movieMetroPhone3],
    desktopImgSrc: [movieMetroMac1, movieMetroMac2],
    tabletImgSrc: [movieMetroTab1, movieMetroTab2],
    mobileFirst: true,
    githubLink: 'https://github.com/shaqdeff/Movie-Metro',
    liveLink: 'https://movie-metro.netlify.app/',
    next: 'abadco',
  },
  {
    id: 'abadco',
    sequence: 6,
    title: 'ABadCo Studios',
    text: [
      "This is a site for a company called ABadCo Studios that's a photography & video production agency. It's a work in progress as I'm still brainstorming on how to make it more appealing for the client, plus other features still need some refining. You can however check it out and interact with it. My favorite part of this project is the video background on the home page that becomes visible via an eraser which is also your cursor.",
    ],
    secondary: [
      'React',
      'Gatsby.js',
      'JavaScript',
      'TypeScript',
      'Styled Components',
      'SCSS',
      'Framer Motion',
    ],
    phoneImgSrc: [abadcoPhone1, abadcoPhone2, abadcoPhone3],
    desktopImgSrc: [abadcoMac1, abadcoMac2],
    tabletImgSrc: [abadcoTab1, abadcoTab2],
    mobileFirst: false,
    githubLink: 'https://github.com/shaqdeff/A-Bad-Co-Studios',
    liveLink: 'https://abadco.netlify.app/',
    next: 'three-graces',
  },
  {
    id: 'three-graces',
    sequence: 7,
    title: 'Three Graces',
    text: [
      "This is a single page site based on Tom Bogner's Dribbble shot The Three Graces. It utilizes Three.js to render the 3D model and apply the spotlight effect.",
    ],
    secondary: ['Three.js', 'JavaScript', 'HTML', 'CSS', 'Webpack'],
    phoneImgSrc: [threeGracesPhone1, threeGracesPhone2, threeGracesPhone3],
    desktopImgSrc: [threeGracesMac1, threeGracesMac2],
    tabletImgSrc: [threeGracesTab1, threeGracesTab2],
    mobileFirst: false,
    githubLink: 'https://github.com/shaqdeff/The-Three-Graces',
    liveLink: 'https://three-graces.netlify.app/',
    next: 'define-consult',
  },
];
